import { useApiTestingLanguage } from './useApiTestingLanguage';
/**
 * EnvironmentCard Component
 * 
 * Displays a single environment with its variables and actions.
 * Extracted from APITesting.js for better maintainability.
 */

import React from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Edit, Trash2 } from 'lucide-react';

export const EnvironmentCard = ({
  environment,
  onEdit,
  onDelete
}) => {
  const { t } = useApiTestingLanguage();
  return (
    <Card className="p-6" data-testid={`environment-card-${environment.id}`}>
      <div className="flex justify-between items-start mb-3">
        <div>
          <h4 className="text-lg font-semibold text-gray-900">{environment.name}</h4>
          {environment.description && (
            <p className="text-gray-600">{environment.description}</p>
          )}
        </div>
        <div className="flex space-x-2">
          <Button 
            variant="outline" 
            size="sm"
            aria-label={t("Edit")}
            onClick={() => onEdit(environment)}
            data-testid={`btn-edit-env-${environment.id}`}
          >
            <Edit className="h-4 w-4" />
          </Button>
          <Button 
            variant="outline" 
            size="sm" 
            className="text-red-600"
            aria-label={t("Delete")}
            onClick={() => onDelete(environment)}
            data-testid={`btn-delete-env-${environment.id}`}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </div>
      
      <div className="space-y-2">
        <p className="text-sm font-medium text-gray-700">{t("Variables:")}</p>
        <div className="bg-gray-50 p-3 rounded-md">
          <pre className="text-xs text-gray-800">
            {JSON.stringify(environment.variables, null, 2)}
          </pre>
        </div>
      </div>
    </Card>
  );
};
